module.exports = __webpack_public_path__ + "img/home_bottom.59a111ad.png";